import React, { Component } from 'react';
import { connect } from 'react-redux';
//import { fromJS, List } from 'immutable';
import L from 'leaflet';
//import shortid from 'shortid';
//import * as ss from 'simple-statistics';
//import * as d3 from 'd3';
import numeral from 'numeral';
import chroma from 'chroma-js';
import FontAwesome from 'react-fontawesome';
//import { point as turf_point, featureCollection as turf_featureCollection } from '@turf/helpers';
import { Map, Pane, TileLayer, LayersControl, ScaleControl, GeoJSON, Tooltip, Popup } from 'react-leaflet'; 
import Control from 'react-leaflet-control';
import LegendScale from './LegendScale';
import ReactLoading from 'react-loading';
import { fetchOverlays, fetchData } from '../../actions'
import { chooseProperty, propertySearch, viewpointChange, recenterMap, loseProperty } from '../../actions/map';
//import { dataFiltered } from '../../actions/data';
//import { filterData } from '../../actions/filter';
import { style_properties } from './overlay_styles.js'; 
import { style_ditches, style_fields, style_fuel_wells, style_cemeteries, style_fuel_tanks, style_pumps, style_mills, style_endangered_species, style_transformers, style_state_land, style_water, style_cade, style_carve_outs, style_camps, style_dumps, style_old_roads, style_pineapple_pesticides, style_pineapple_fields, style_cesspools } from './overlay_styles.js'; 
//import { onEveryFeatureProperties } from './overlay_styles.js';
import { onEveryFeatureRes, onEveryFeatureFuelTanks, onEveryFeatureCesspools, onEveryFeatureFuelWells, onEveryFeatureFields, onEveryFeatureFieldsLabels } from './overlay_styles.js';
import 'font-awesome/css/font-awesome.css';
import 'leaflet/dist/leaflet.css';
import map_styles from '../../css/map.css';

const { BaseLayer, Overlay } = LayersControl 

/*const format = (number) => {
  var form = "";
  number = parseFloat(number)
  switch (true){
    case (number >= 10000 || number%1 === 0):
      form = ".2s";
    break
    case (number < 10000 && number >= 100):
      form = ".5r";
    break
    case (number < 100 && number >= .001):
      form = ".3r";
    break
    case (number < .001):
      form = ".0e"
    break
    default:
  }
  return d3.format(form)(number);
}*/

const LegendRow = (props) => {
  var text = props.category;
  let color = props.color;

  if(!text) {
    text = 'Null';
  }

  return (
    <div className='legendRow' >
      <div style={{minWidth:50 + 'px', float:'left'}}>
        <div className='legendCircle' style={{
          "background": color,
          "borderRadius":0,
          "width": 50 + 'px',
          "height": 25 + 'px',
          "border":"3px solid " + color,
          "marginTop": "5px",
          "marginBottom": "5px",
          "marginRight": "5px",
          "marginLeft": 5 + 'px'
        }}>
        </div>
      </div>
      <div style={{paddingTop: 7.5 + 'px', minWidth: 50 + 'px', float:'left' }}>
        {text}
      </div>
      <div style={{clear:"both"}}></div>
    </div>
  )
}

const Legend = (props) => { 
  let values = props.categories;
  let colors = props.colors;
  let title = props.scalar;

  var legendRows = [];

  for(let i = 0; i < values.size; i++) {
    legendRows.push((
        <LegendRow key={i} i={i} color={colors[i]} category={values.get(i)} />
    ));
  }

  return (
    <div style={{margin:'10px', padding:'10px', background:'rgba(255,255,255,.9)', borderRadius:"5px", 'boxShadow': '0px 1px 5px rgba(0,0,0,0.35)'}}>
      <h4>{title}</h4>
      {legendRows}
    </div>
  );

};

const LegendContinuous = (props) => { 
  let title = props.scalar;
  let min = props.min;
  let max = props.max;
  let fill = props.colorScale;

  return (
    <div style={{margin:'10px', padding:'10px', background:'rgba(255,255,255,.9)', borderRadius:"5px", 'boxShadow': '0px 1px 5px rgba(0,0,0,0.35)'}}>
      <h4>{title}</h4>
      <LegendScale height={250} width={150} fill={fill} min={min} max={max} />
    </div>
  );

};

class DataMapViewComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltips: true,
      draggable:true
    }
  }

  componentWillMount(){
    if(this.props.properties.size === 0) {
      this.props.dispatch(fetchOverlays());
    }
    if(this.props.data.size === 0) {
      this.props.dispatch(fetchData());
    }
  }

  componentDidUpdate(){
    const { popupLocation } = this.refs //, edit
    if(this.props.foundProperty && popupLocation) {
      popupLocation.leafletElement.openPopup()
      setTimeout(function(){
        this.props.dispatch(loseProperty());
      }.bind(this), 5000);  // wait 5 seconds, then clear out the chosen location.
    }
  }

  handleAllPropertyClick(e){
    this.props.dispatch(chooseProperty(e.layer.feature.properties.cty_tmk));
  }
  handlePropertyClick(property){
    this.props.dispatch(chooseProperty(property));
  }
  handlePropertyHover(e){
    e.target.bringToFront();
  }

  performPropertySearch(e){
    if(e.keyCode === 13) {
      this.props.dispatch(propertySearch(e.target.value));
    }
  }

  clearPropertySearchProps() {
    this.props.dispatch(loseProperty());
  }

  recenterMap() { 
    this.props.dispatch(recenterMap());
  }

  toggleTooltips() {
    this.setState({ tooltips: !this.state.tooltips })
  }

  viewpointChanged(viewpoint){
    this.props.dispatch(viewpointChange(viewpoint));
  }

  render() {
    var isBusy = this.props.isBusy;
    var propertySearch =(<input className="form-control" type="search" placeholder="find a property by TMK" onKeyDown={this.performPropertySearch.bind(this)} tabIndex="0" style={{'width':'200px', 'height':'45px', 'marginRight':'350px', 'padding':'10px', 'background':'rgba(255,255,255,.9)', 'borderRadius':"5px", 'boxShadow': '0px 1px 5px rgba(0,0,0,0.35)'}}/>)
    var fitBounds =(
      <button className="recenterButton" onClick={() => this.recenterMap()} type="button" style={{'cursor': 'pointer', 'width':'34px', 'height':'33px'}}>
        <span style={{ textAlign: 'center' }}><FontAwesome name='crosshairs' style={{textAlign: 'center', textShadow: '0 1px 0 rgba(0, 0, 0, 0.1)', 'fontSize': '20px', verticalAlign: 'middle', 'lineHeight': '20px' }} /></span>
      </button>
    )

    /*var properties = undefined;
    if(this.props.properties.size > 0) {
      properties = (<GeoJSON key={1} data={this.props.properties.toJSON()} style={style_outline_properties} ></GeoJSON>);
    }*/

    var ditches = undefined,
        fields = undefined,
        fieldsLabeled = undefined,
        //wells = undefined,
        //wells_dom = undefined,
        //wells_mun = undefined,
        reservoirs = undefined,
        fuel_wells = undefined,
        fuel_tanks = undefined,
        pumps = undefined,
        camps = undefined,
        dumping = undefined,
        other = undefined,
        cade = undefined,
        carve = undefined,
        old_roads = undefined,
        mills = undefined,
        //landfills = undefined,
        cemeteries = undefined,
        state_land = undefined,
        endangered_species = undefined,
        transformers = undefined,
        pineapple_fields = undefined,
        pineapple_pesticides = undefined,
        cesspools = undefined,
        include_properties;
  
    if(this.props.overlays.size > 0) {
      var overlays = this.props.overlays.toJS()
   
      ditches = (<GeoJSON key={3} data={overlays[0]} style={style_ditches}></GeoJSON>);
      fields = (<GeoJSON key={4} data={overlays[1]} onEachFeature={onEveryFeatureFields} style={style_fields}></GeoJSON>);
      fieldsLabeled = (<GeoJSON key={8} data={overlays[1]} onEachFeature={onEveryFeatureFieldsLabels} style={style_fields}></GeoJSON>);
      //wells = (<GeoJSON key={5} data={overlays[2]} onEachFeature={onEveryFeatureWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_wells);}}></GeoJSON>);
      //wells_dom = (<GeoJSON key={6} data={overlays[3]} onEachFeature={onEveryFeatureWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_wells_dom);}}></GeoJSON>);
      //wells_mun = (<GeoJSON key={7} data={overlays[4]} onEachFeature={onEveryFeatureWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_wells_mun);}}></GeoJSON>);
      reservoirs = (<GeoJSON key={9} data={overlays[5]} onEachFeature={onEveryFeatureRes} style={style_water}></GeoJSON>);
      fuel_wells = (<GeoJSON key={10} data={overlays[6]} onEachFeature={onEveryFeatureFuelWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_fuel_wells);}}></GeoJSON>);
      fuel_tanks = (<GeoJSON key={11} data={overlays[7]} onEachFeature={onEveryFeatureFuelTanks} style={style_fuel_tanks}></GeoJSON>);
      pumps = (<GeoJSON key={12} data={overlays[8]} onEachFeature={onEveryFeatureFuelWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_pumps);}}></GeoJSON>);
      camps = (<GeoJSON key={13} data={overlays[9]} onEachFeature={onEveryFeatureRes} style={style_camps}></GeoJSON>);
      dumping = (<GeoJSON key={14} data={overlays[10]} onEachFeature={onEveryFeatureRes} style={style_dumps}></GeoJSON>);
      other = (<GeoJSON key={15} data={overlays[11]} onEachFeature={onEveryFeatureRes} style={style_fields}></GeoJSON>);
      cade = (<GeoJSON key={16} data={overlays[12]} onEachFeature={onEveryFeatureRes} style={style_cade}></GeoJSON>);
      carve = (<GeoJSON key={17} data={overlays[13]} onEachFeature={onEveryFeatureRes} style={style_carve_outs}></GeoJSON>);
      old_roads = (<GeoJSON key={18} data={overlays[14]} style={style_old_roads}></GeoJSON>);
      mills = (<GeoJSON key={19} data={overlays[15]} onEachFeature={onEveryFeatureRes} style={style_mills}></GeoJSON>);
      //landfills = (<GeoJSON key={20} data={overlays[16]} onEachFeature={onEveryFeatureRes} style={style_landfills}></GeoJSON>);
      cemeteries = (<GeoJSON key={21} data={overlays[16]} onEachFeature={onEveryFeatureFuelWells} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_cemeteries);}}></GeoJSON>);
      state_land = (<GeoJSON key={22} data={overlays[17]} onEachFeature={onEveryFeatureRes} style={style_state_land}></GeoJSON>);
      endangered_species = (<GeoJSON key={23} data={overlays[18]} onEachFeature={onEveryFeatureRes} style={style_endangered_species}></GeoJSON>);
      transformers = (<GeoJSON key={24} data={overlays[19]} onEachFeature={onEveryFeatureRes} style={style_transformers}></GeoJSON>);
      
      include_properties = (<GeoJSON key={25} data={overlays[20]} style={style_properties} ></GeoJSON>);

      cesspools = (<GeoJSON key={26} data={overlays[21]} onEachFeature={onEveryFeatureCesspools} pointToLayer={function(feature, latlng){return L.circleMarker(latlng, style_cesspools);}} ></GeoJSON>);
      pineapple_fields = (<GeoJSON key={27} data={overlays[22]} onEachFeature={onEveryFeatureRes} style={style_pineapple_fields} ></GeoJSON>);
      pineapple_pesticides = (<GeoJSON key={28} data={overlays[23]} onEachFeature={onEveryFeatureRes} style={style_pineapple_pesticides} ></GeoJSON>);
    }

    var data = this.props.filteredProperties,//.filter(x => x.get('visible')),
        filteredProperties = null,
        colors,
        colorFx,
        foundFx,
        selectedFx,
        highlightFx,
        noShowFx,
        mouseoverFx,
        weight,
        scalar = this.props.parameter.value,
        scalarLabel = this.props.parameter.label,
        scalarType = this.props.parameterType,
        maxStat,
        minStat,
        values,
        legend = null,
        key;

    let colorScales = {
      value: 'Oranges',
      acres_owned: chroma.scale('YlGn').gamma(2),
      acres: chroma.scale('YlGn').gamma(2),
      owner: 'Set1',
      is_core: ['yellow', 'red', 'black'],
      portion_reserved_at_closing: 'PRGn',
      request_for_deregistration_submitted: 'Dark2',
      is_title_insurable: 'BrBG',
      is_ial: 'Paired',
      ab_risk_rank: 'RdYlBu',
      m_risk_rank: 'OrRd'
    }

    if(data.size){

      noShowFx = function(feature){
        return {
          color: 'charcoal',
          opacity: 0,
          fillColor: 'charcoal',
          fillOpacity: 0,
          weight: 0
        }
      }

      mouseoverFx = function(feature,layer) {
        weight = layer.options.weight;
        layer.on("mouseover",function(e){
            layer.setStyle({weight: (weight * 1.5)}) 
        });
        layer.on("mouseout",function(e){
            layer.setStyle({weight: weight}) 
        });
      }

      if(scalar && scalarType === 'Continuous' && this.props.fillProperties){

        maxStat = data.filter(row => row.get('visible')).map((row) => +row.get('data').get(scalar) || 0).max();
        minStat = data.filter(row => row.get('visible')).map((row) => +row.get('data').get(scalar) || 0).min();
      
        if(scalar === 'acres_owned' || scalar === 'acres') {
          colors = chroma.scale('YlGn').gamma(2).domain([minStat, maxStat])
        } else {
          colors = chroma.scale(['yellow', 'navy']).mode('lch').domain([minStat, maxStat])//.gamma(0.5);
        }
   
        colorFx = function(feature){
          return {
            color: colors(+feature.data[scalar]),
            opacity: 0.8,
            fillColor: colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 0.6
          };
        }

        highlightFx = function(feature){
          return {
            color: map_styles.highlightColor,
            opacity: 1,
            fillColor: map_styles.highlightColor, //colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 1
          };
        }

        selectedFx = function(feature){
          return {
            color: map_styles.selectedColor,
            opacity: 1,
            fillColor: map_styles.selectedColor, //colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 1
          };
        }

        foundFx = function(feature){
          return {
            color: map_styles.foundColor,
            opacity: 1,
            fillColor: map_styles.foundColor, //colors(+feature.data[scalar]),
            fillOpacity: 0.8,
            weight: 1
          };
        }
     
        legend = (
          <LegendContinuous scalar={this.props.parameter.label} min={minStat} max={maxStat} colorScale={colors} />
        )
      } else if(scalar && scalarType === 'Discrete' && this.props.fillProperties) {
        
        if(scalar !== 'm_risk_rank') {
          values = this.props.allData.map((row) => row.get(scalar)).toSet().toList();
        } else {
          values = this.props.allData.filter((row) => row.get(scalar)).map((row) => row.get(scalar)).toSet().toList();
        }

        colors = chroma.scale(colorScales[scalar]).padding(-0.15).colors(values.size);

        colorFx = function(feature){
          return {
            color: colors[values.indexOf(feature.data[scalar])],
            opacity: 0.8,
            fillColor: colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.5,
            weight: 0.6
          };
        }

        highlightFx = function(feature){
          return {
            color: map_styles.highlightColor,
            opacity: 1,
            fillColor: map_styles.highlightColor, //colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.8,
            weight: 1
          };
        }

        selectedFx = function(feature){
          return {
            color: map_styles.selectedColor,
            opacity: 1,
            fillColor: map_styles.selectedColor, //colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.8,
            weight: 1
          };
        }

        foundFx = function(feature){
          return {
            color: map_styles.foundColor,
            opacity: 1,
            fillColor: map_styles.foundColor, //colors[values.indexOf(feature.data[scalar])],
            fillOpacity: 0.8,
            weight: 1
          };
        }
     
        legend = (
          <Legend categories={values} scalar={this.props.parameter.label} colors={colors} />
        )
      } else {
        colors = null;
      
        colorFx = function(feature){
          return {
            color: '#3e3e3f',
            opacity: 1,
            fillColor: 'white',
            fillOpacity: 0,
            weight: 1.5
          };
        }

        highlightFx = function(feature){
          return {
            color: map_styles.highlightColor,
            opacity: 1,
            fillColor: map_styles.highlightColor,
            fillOpacity: 0.2,
            weight: 1
          };
        }

        selectedFx = function(feature){
          return {
            color: map_styles.selectedColor,
            opacity: 1,
            fillColor: map_styles.selectedColor,
            fillOpacity: 0.2,
            weight: 1
          };
        }

        foundFx = function(feature){
          return {
            color: map_styles.foundColor,
            opacity: 1,
            fillColor: map_styles.foundColor,
            fillOpacity: 0.2,
            weight: 3
          };
        }
        legend = null;
      }

      filteredProperties = data.map( (row, i) => {

          key = i;
          //key = row.get('data').get('id')

          if(!row.get('visible')) {
            return (
              <GeoJSON 
                key={key} 
                data={row.toJS()}
                style={noShowFx}
              >
              </GeoJSON>
            )
          } else if(this.props.foundProperty && row.get('cty_tmk') === this.props.foundProperty && row.get('visible')) {
            return (
              <GeoJSON 
                key={'1f'} 
                ref="popupLocation" 
                data={row.toJS()} 
                style={foundFx} 
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))} 
                onMouseover={this.handlePropertyHover.bind(this)}
              >
                <Popup>
                  <span>{row.get('data').get('cty_tmk')}</span>
                </Popup>
              </GeoJSON>
            )
          } else if(this.props.selectedProperty && row.get('cty_tmk') === this.props.selectedProperty && row.get('visible')) { 
            return (
              <GeoJSON 
                key={key} 
                data={row.toJS()} 
                style={selectedFx} 
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))} 
                onMouseover={this.handlePropertyHover.bind(this)}
              >
              {this.state.tooltips ? (
                  scalar !== undefined ? (
                    scalarType === 'Continuous' ? ( 
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + numeral(+row.get('data').get(scalar)).format('0,0')}</span>
                      </Tooltip> ) : (
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + row.get('data').get(scalar)}</span>
                      </Tooltip>)
                    ) : (
                    <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                      <span>{row.get('data').get('cty_tmk')}</span>
                    </Tooltip> ) 
                  ) : ( null )
                }
              </GeoJSON>
            )
          } else if(this.props.histogramSelection[0] && this.props.parameterType === 'Discrete' && row.get('data').get(this.props.parameter.value) === (this.props.histogramSelection[0] === 'Null' ? null : this.props.histogramSelection[0]) && row.get('visible')) {
            return (
              <GeoJSON 
                key={key} 
                data={row.toJS()} 
                style={highlightFx} 
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))} 
                onMouseover={this.handlePropertyHover.bind(this)}
              >
              {this.state.tooltips ? (
                <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                  <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + row.get('data').get(scalar)}</span>
                </Tooltip>
                ) : ( null )
              }
              </GeoJSON>
            )
          } else if(this.props.histogramSelection[0] && this.props.parameterType === 'Continuous' && +row.get('data').get(this.props.parameter.value) <= this.props.histogramSelection[1] && +row.get('data').get(this.props.parameter.value) > this.props.histogramSelection[0] && row.get('visible')) {
            return (
              <GeoJSON 
                key={key} 
                data={row.toJS()} 
                style={highlightFx} 
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))} 
                onMouseover={this.handlePropertyHover.bind(this)}
              >
              {this.state.tooltips ? (
                <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                  <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + numeral(+row.get('data').get(scalar)).format('0,0')}</span>
                </Tooltip>
                ) : ( null )
              }
              </GeoJSON>
            )
          } else {
            return (
              <GeoJSON 
                key={key} 
                ref="popupLocation" 
                data={row.toJS()} 
                style={colorFx} 
                onClick={this.handlePropertyClick.bind(this, row.get('data').get('cty_tmk'))} 
                onMouseover={this.handlePropertyHover.bind(this)}
                onEachFeature={mouseoverFx}
              >
                {this.state.tooltips ? (
                  scalar !== undefined ? (
                    scalarType === 'Continuous' ? ( 
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + numeral(+row.get('data').get(scalar)).format('0,0')}</span>
                      </Tooltip> ) : (
                      <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                        <span>{row.get('data').get('cty_tmk')}<br></br>{'' + scalarLabel + ': ' + row.get('data').get(scalar)}</span>
                      </Tooltip>)
                    ) : (
                    <Tooltip direction='top' offset={[0, 2]} opacity={1}>
                      <span>{row.get('data').get('cty_tmk')}</span>
                    </Tooltip> ) 
                  ) : ( null )
                }
              </GeoJSON>
            )
          }
        }
      )
    }

    return (
      <div className="map_container" style={{height: this.props.height}}>
        {isBusy ? (
          <div style={{marginTop: (this.props.height * 0.25), marginLeft: (this.props.width * 0.25), zIndex:1000000, width:'25%', height:'25%', backgroundColor:'rgba(255,255,255,0.0)', position:'absolute'}}>
            <ReactLoading type='bubbles' color='#333333' height='25%' width='50%' className='center-loader' />
          </div>) : (
          <div></div>
         )}
         <Map ref="map" center={this.props.mapCenter} zoom={this.props.mapZoom} onViewportChanged={this.viewpointChanged.bind(this)}>
          <LayersControl position='topleft'>
            <BaseLayer name='Open Street Map - Black And White'>
              <TileLayer
                url='https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.{ext}'
                attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                minZoom={0}
                maxZoom={18}
                ext='png'
              />
            </BaseLayer>
            <BaseLayer name='Stamen - Terrain'>
              <TileLayer
                url='https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.{ext}'
                attribution='Map tiles by <a href="https://stamen.com">Stamen Design</a>, <a href="https://creativecommons.org/licenses/by/3.0">CC BY 3.0</a>'
                subdomains='abcd'
                minZoom={0}
                maxZoom={18}
                ext='png'
              />
            </BaseLayer>
            <BaseLayer name='Stamen - Terrain [Background]'>
              <TileLayer
                url='https://stamen-tiles-{s}.a.ssl.fastly.net/terrain-background/{z}/{x}/{y}{r}.{ext'
                attribution='Map tiles by <a href="http://stamen.com">Stamen Design</a>, <a href="http://creativecommons.org/licenses/by/3.0">CC BY 3.0</a> &mdash; Map data &copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
                subdomains='abcd'
                minZoom={0}
                maxZoom={18}
                ext='png'
              />
            </BaseLayer>
            <BaseLayer name='ESRI - World Topology'>
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}'
                attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ, TomTom, Intermap, iPC, USGS, FAO, NPS, NRCAN, GeoBase, Kadaster NL, Ordnance Survey, Esri Japan, METI, Esri China (Hong Kong), and the GIS User Community'
              />
            </BaseLayer>
            <BaseLayer checked name='ESRI - World Imagery'>
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
              />
            </BaseLayer>
            <BaseLayer name='ESRI - Grey Map'>
              <TileLayer
                url='https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}'
                attribution='Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ'
              />
            </BaseLayer>
            <BaseLayer name='CartoDB - Positron'>
              <TileLayer
                url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png'
                attribution='&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
                subdomains='abcd'
                maxZoom={19}
              />
            </BaseLayer>
            <BaseLayer name='CartoDB - Dark Matter'>
              <TileLayer
                url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/dark_all/{z}/{x}/{y}.png'
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://cartodb.com/attributions">CartoDB</a>'
                subdomains='abcd'
                maxZoom={19}
              />
            </BaseLayer>
            {include_properties !== undefined ? (<Overlay checked name='Include/Option Properties'>
              {include_properties}
            </Overlay>) : null }
            {carve !== undefined ? (<Overlay name='Carve Outs'>
              {carve}
            </Overlay>) : null }
            {fields !== undefined ? (<Overlay name='Fields'>
              {fields}
            </Overlay>) : null }
            {fieldsLabeled !== undefined ? (<Overlay name='Fields (Labeled)'>
              {fieldsLabeled}
            </Overlay>) : null }
            {pineapple_fields !== undefined ? (<Overlay name='Pineapple Fields'>
              {pineapple_fields}
            </Overlay>) : null }
            {reservoirs !== undefined ? (<Overlay name='Reservoirs'>
              {reservoirs}
            </Overlay>) : null }
            {ditches !== undefined ? (<Overlay name='Ditches'>
              {ditches}
            </Overlay>) : null }
            {old_roads !== undefined ? (<Overlay name='Old Government Roads'>
              {old_roads}
            </Overlay>) : null }
            {cesspools !== undefined ? (<Overlay name='Cesspools'>
              {cesspools}
            </Overlay>) : null }
            {fuel_wells !== undefined ? (<Overlay name='Wells'>
              {fuel_wells}
            </Overlay>) : null }
            {fuel_tanks !== undefined ? (<Overlay name='Fuel Tanks'>
              {fuel_tanks}
            </Overlay>) : null }
            {pumps !== undefined ? (<Overlay name='Pumps'>
              {pumps}
            </Overlay>) : null }
            {transformers !== undefined ? (<Overlay name='Transformers'>
              {transformers}
            </Overlay>) : null }
            {camps !== undefined ? (<Overlay name='Camps'>
              {camps}
            </Overlay>) : null }
            {dumping !== undefined ? (<Overlay name='Dumps/Landfills'>
              {dumping}
            </Overlay>) : null }
            {cade !== undefined ? (<Overlay name='CADE (Plant and Stations)'>
              {cade}
            </Overlay>) : null }
            {pineapple_pesticides !== undefined ? (<Overlay name='Pineapple Pesticide Mixing Stations'>
              {pineapple_pesticides}
            </Overlay>) : null }
            {mills !== undefined ? (<Overlay name='Mills'>
              {mills}
            </Overlay>) : null }
            {cemeteries !== undefined ? (<Overlay name='Cemeteries'>
              {cemeteries}
            </Overlay>) : null }
            {other !== undefined ? (<Overlay name='Other Env. Issues'>
              {other}
            </Overlay>) : null }
            {state_land !== undefined ? (<Overlay name='State Ownership'>
              {state_land}
            </Overlay>) : null }
            {endangered_species !== undefined ? (<Overlay name='Has Endangered Species'>
              {endangered_species}
            </Overlay>) : null }
            {/*wells !== undefined ? (<Overlay name='All Wells'>
              {wells}
            </Overlay>) : null }
            {wells_dom !== undefined ? (<Overlay name='Domestic Wells'>
              {wells_dom}
            </Overlay>) : null }
            {wells_mun !== undefined ? (<Overlay name='Municipal Wells'>
              {wells_mun}
            </Overlay>) : null */}
          </LayersControl>
          <Control position="bottomleft">
            <div style={{zIndex: 100}}>
              { this.props.fillProperties && this.props.parameter ? legend : null }
            </div>
          </Control>
          <Control position="topright">
            <div>
              {propertySearch}
            </div>
          </Control>
          <Control position="topright">
            <div className="recenter-div">
              {fitBounds}
            </div>
          </Control>
          <Pane name="leaflet-properties-overlay-pane" style={{ zIndex: 450 }}>
            {/*{this.props.showProperties && properties ? (properties) : null}*/}
            {this.props.showProperties && filteredProperties ? (filteredProperties) : null}
          </Pane>
          <ScaleControl position='bottomright' />
        </Map>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.DataApp.get('filteredProperties'),
    allData: state.DataApp.get('data'),
    selectedProperty: state.DataApp.get('selectedProperty'),
    properties: state.DataApp.get('properties'),
    filteredProperties: state.DataApp.get('filteredProperties'),

    showProperties: state.StatApp.get('showProperties'),
    showRadius: state.StatApp.get('showRadius'),
    fillProperties: state.StatApp.get('fillProperties'),
    //radius: state.StatApp.get('radius'),
    //showClusters: state.StatApp.get('showClusters'),
    //mapBreaks: state.StatApp.get('mapBreaks'),
    parameter: state.StatApp.get('parameter'),
    parameterType: state.StatApp.get('parameterType'),
    histogramSelection: state.StatApp.get('histogramSelection'),

    foundProperty: state.MapApp.get('foundProperty'),
    overlays: state.MapApp.get('overlays'),
    mapCenter: state.MapApp.get('mapCenter'),
    mapZoom: state.MapApp.get('mapZoom'),
    mapBounds: state.MapApp.get('mapBounds'),
    draggable: state.MapApp.get('draggable'),
    errorMessage: state.MapApp.get('errorMessage'),
    template: state.Template,
    isBusy: state.isBusy
  }
}

const DataMapView = connect(mapStateToProps)(DataMapViewComp)

export default DataMapView;



// WEBPACK FOOTER //
// ./src/components/MapView/DataMapView.js